export default {
  CRITICAL: 'Critical',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  INFO: 'Info',
  HIGHLIGHT: 'Highlight',
  NEUTRAL: 'Neutral',
  INTERNAL: 'Internal',
  PASSIVE: 'Passive',
  PREMIUM: 'Premium'
};
